/* eslint-disable */
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "od_protos.touring.data";

/** TourTimeSlot represents a time slot that a tour was requested for. */
export interface TourTimeSlot {
  /** The state of the tour time slot */
  state: TourTimeSlot_State;
  /** The party proposing the tour time slot (e.g. seller or buyer) */
  proposer: TourTimeSlot_Proposer;
  /** The start time of the tour time slot */
  start?:
    | Date
    | undefined;
  /** The end time of the tour time slot */
  end?: Date | undefined;
}

/** State represents the state of the tour time slot */
export enum TourTimeSlot_State {
  UNKNOWN_STATE = 0,
  /**
   * PROPOSED - The tour time slot has been proposed and is pending acceptance/rejection
   * by the other party
   */
  PROPOSED = 1,
  /** REJECTED - The tour time slot has been rejected */
  REJECTED = 2,
  /** ACCEPTED - The tour time slot has been accepted */
  ACCEPTED = 3,
  UNRECOGNIZED = -1,
}

export function tourTimeSlot_StateFromJSON(object: any): TourTimeSlot_State {
  switch (object) {
    case 0:
    case "UNKNOWN_STATE":
      return TourTimeSlot_State.UNKNOWN_STATE;
    case 1:
    case "PROPOSED":
      return TourTimeSlot_State.PROPOSED;
    case 2:
    case "REJECTED":
      return TourTimeSlot_State.REJECTED;
    case 3:
    case "ACCEPTED":
      return TourTimeSlot_State.ACCEPTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TourTimeSlot_State.UNRECOGNIZED;
  }
}

export function tourTimeSlot_StateToJSON(object: TourTimeSlot_State): string {
  switch (object) {
    case TourTimeSlot_State.UNKNOWN_STATE:
      return "UNKNOWN_STATE";
    case TourTimeSlot_State.PROPOSED:
      return "PROPOSED";
    case TourTimeSlot_State.REJECTED:
      return "REJECTED";
    case TourTimeSlot_State.ACCEPTED:
      return "ACCEPTED";
    case TourTimeSlot_State.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Proposer represents the party proposing the tour time slot */
export enum TourTimeSlot_Proposer {
  UNKNOWN_PROPOSER = 0,
  /** TOURING_CUSTOMER - The touring customer proposed the tour time slot */
  TOURING_CUSTOMER = 1,
  /** SELLER - The seller proposed the tour time slot */
  SELLER = 2,
  UNRECOGNIZED = -1,
}

export function tourTimeSlot_ProposerFromJSON(object: any): TourTimeSlot_Proposer {
  switch (object) {
    case 0:
    case "UNKNOWN_PROPOSER":
      return TourTimeSlot_Proposer.UNKNOWN_PROPOSER;
    case 1:
    case "TOURING_CUSTOMER":
      return TourTimeSlot_Proposer.TOURING_CUSTOMER;
    case 2:
    case "SELLER":
      return TourTimeSlot_Proposer.SELLER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TourTimeSlot_Proposer.UNRECOGNIZED;
  }
}

export function tourTimeSlot_ProposerToJSON(object: TourTimeSlot_Proposer): string {
  switch (object) {
    case TourTimeSlot_Proposer.UNKNOWN_PROPOSER:
      return "UNKNOWN_PROPOSER";
    case TourTimeSlot_Proposer.TOURING_CUSTOMER:
      return "TOURING_CUSTOMER";
    case TourTimeSlot_Proposer.SELLER:
      return "SELLER";
    case TourTimeSlot_Proposer.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseTourTimeSlot(): TourTimeSlot {
  return { state: 0, proposer: 0, start: undefined, end: undefined };
}

export const TourTimeSlot = {
  fromJSON(object: any): TourTimeSlot {
    return {
      state: isSet(object.state) ? tourTimeSlot_StateFromJSON(object.state) : 0,
      proposer: isSet(object.proposer) ? tourTimeSlot_ProposerFromJSON(object.proposer) : 0,
      start: isSet(object.start) ? fromJsonTimestamp(object.start) : undefined,
      end: isSet(object.end) ? fromJsonTimestamp(object.end) : undefined,
    };
  },

  toJSON(message: TourTimeSlot): unknown {
    const obj: any = {};
    if (message.state !== 0) {
      obj.state = tourTimeSlot_StateToJSON(message.state);
    }
    if (message.proposer !== 0) {
      obj.proposer = tourTimeSlot_ProposerToJSON(message.proposer);
    }
    if (message.start !== undefined) {
      obj.start = message.start.toISOString();
    }
    if (message.end !== undefined) {
      obj.end = message.end.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TourTimeSlot>, I>>(base?: I): TourTimeSlot {
    return TourTimeSlot.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TourTimeSlot>, I>>(object: I): TourTimeSlot {
    const message = createBaseTourTimeSlot();
    message.state = object.state ?? 0;
    message.proposer = object.proposer ?? 0;
    message.start = object.start ?? undefined;
    message.end = object.end ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
